export default "__VITE_ASSET__DghcckaU__"